import InvoiceTable from '@accounting/components/tables/invoice-table/invoice-table.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-profile-invoices',
  components: {
    'bpc-invoice-table': InvoiceTable,
  },
})
export default class ProfileInvoices extends Vue {
  get contactId() {
    return this.$authorizationService.getContactId();
  }

  get profileFilters() {
    return [
      { filterField: 'contact_id', modelField: null, value: this.contactId },
      { filterField: 'avoidDraft', modelField: null, value: true },
    ];
  }

  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get contactType(): string {
    return this.$store.getters['auth/profile']({ tenantId: this.tenantId })?.contact_type || null;
  }

  get displayConfigName() {
    return this.contactType === 'individual' ? 'my-invoice' : 'organization-invoices';
  }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
